import { render, staticRenderFns } from "./ModelInfoModal.vue?vue&type=template&id=60cc7848&scoped=true"
import script from "./ModelInfoModal.vue?vue&type=script&lang=js"
export * from "./ModelInfoModal.vue?vue&type=script&lang=js"
import style0 from "./ModelInfoModal.vue?vue&type=style&index=0&id=60cc7848&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60cc7848",
  null
  
)

export default component.exports